
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ExportDatabaseType enum
 */
class ExportDatabaseType {
  /**
   * Initialize enum with a given value
   * @param {ExportDatabaseType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ExportDatabaseType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ExportDatabaseType}
   * @param {!ExportDatabaseType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ExportDatabaseType)) {
      throw new TypeError('Instance of ExportDatabaseType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ExportDatabaseType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ExportDatabaseType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ExportDatabaseType.MYSQL.value) {
      return 'MYSQL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ExportDatabaseType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ExportDatabaseType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ExportDatabaseType} Created enum
   */
  static fromObject (other) {
    return new ExportDatabaseType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ExportDatabaseType.MYSQL = new ExportDatabaseType(0 + 0)

export { ExportDatabaseType };

/**
 * Fast Binary Encoding ExportDatabaseType field model
 */
class FieldModelExportDatabaseType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelExportDatabaseType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelExportDatabaseType}
   * @param {ExportDatabaseType=} defaults Default value, defaults is new ExportDatabaseType()
   * @returns {!ExportDatabaseType} Result value
   */
  get (defaults = new ExportDatabaseType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ExportDatabaseType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelExportDatabaseType}
   * @param {!ExportDatabaseType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelExportDatabaseType };
